import {inferServiceBrandFromWindow} from '@practicegenius/domain/src/data/serviceBrand';
import {GOOGLE_RECAPTCHA_SITE_KEY, MY_DOT_URL} from '../constants/env';
import {
  ServiceBrandType,
  ServiceBrandInterface,
} from '../@practicegenius/utils/ServiceBrand';

const ServiceBrand: ServiceBrandInterface = {
  PRH: 'prh',
  HUBBUX: 'hubbux',
  CULTURELLO: 'culturello',

  get current(): ServiceBrandType {
    const serviceBrand = inferServiceBrandFromWindow();
    const hostToBrand = {
      patientrewardshub: this.PRH,
      hubbux: this.HUBBUX,
      culturello: this.CULTURELLO,
    };

    return hostToBrand[serviceBrand] || this.PRH;
  },

  get lang() {
    return {
      practiceNoun: this.select({
        prh: 'practice',
        hubbux: 'business',
        culturello: 'business',
      }),
      hubProduct: this.select({
        prh: 'Patient Rewards Hub',
        hubbux: 'Hubbux',
        culturello: 'Culturello',
      }),
      appUrlAndroid: this.select({
        prh: 'https://play.google.com/store/apps/details?id=com.practicegenius.hubapp1',
        hubbux:
          'https://play.google.com/store/apps/details?id=com.practicegenius.hubbux',
        culturello:
          'https://play.google.com/store/apps/details?id=com.culturello.Culturello',
      }),
      appUrlIos: this.select({
        prh: 'https://itunes.apple.com/us/app/patient-rewards-hub/id962626763?ls=1&mt=8',
        hubbux: 'https://itunes.apple.com/us/app/hubbux-rewards/id1164729911',
        culturello: 'https://itunes.apple.com/us/app/culturello/id6738893094',
      }),
    };
  },

  get data() {
    return {
      myDotUrl: this.select({
        prh: MY_DOT_URL.PRH,
        hubbux: MY_DOT_URL.HUBBUX,
        culturello: MY_DOT_URL.CULTURELLO,
      }),
      googleRecaptchaSiteKey: this.select({
        prh: GOOGLE_RECAPTCHA_SITE_KEY.PRH,
        hubbux: GOOGLE_RECAPTCHA_SITE_KEY.HUBBUX,
        culturello: GOOGLE_RECAPTCHA_SITE_KEY.CULTURELLO,
      }),
    };
  },

  select<P, H, C>(criteria: {prh: P; hubbux: H; culturello: C}): P | H | C {
    return criteria[this.current];
  },
};

export default ServiceBrand;
